/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { pxToEm } from '@insticator/insticator-ui';



/* ++++++++++ --------------- HISTORICAL DATA - CONFIGURATION PAGE : STYLES --------------- ++++++++++ */
import {pxToEm, themeV2} from "@insticator/insticator-ui";

export default {
  historical: {
    '& .descriptionWidth': {
      width: '55%'
    },

    '& .btnDownload':{
      border: '1px solid #061240',
      backgroundColor: 'white',
      marginLeft: pxToEm(20),

      '& i': {
        color: themeV2.color.primary.main,
        fontSize: '100%',
        padding: 0
      }
    },

    '& .name-arrow-down': {
      pointerEvents: 'none',
      opacity: '0',
      animationName: 'fadeInDown',
      animationDuration: '1s',
      animationFillMode: 'forwards',
      animationIterationCount: 'infinite',
    }
  }
};
